module.exports = __webpack_public_path__ + "static/media/cover7.6165baba.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover7.png
// module id = 560
// module chunks = 0